import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { TranslateService } from "@ngx-translate/core";

export class OrderStateRenderer {
  constructor(protected translateService: TranslateService) {}

  public getStateAsString(state: CubiqTS.OrderState, lockType: CubiqTS.LockType = null): string {
    switch (state) {
      case CubiqTS.OrderState.PRICED:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.PRICED]}`,
        );
      case CubiqTS.OrderState.CREDIT_CHECKING:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.CREDIT_CHECKING]}`,
        );
      case CubiqTS.OrderState.DI_NEEDED:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.DI_NEEDED]}`,
        );
      case CubiqTS.OrderState.DI_APPROVED:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.DI_APPROVED]}`,
        );
      case CubiqTS.OrderState.ACCEPTANCE_NEEDED:
        if (lockType != null && lockType == CubiqTS.LockType.MODIFY_LOCK) {
          // if (params.data['orderId'] != null) {
          return this.translateService.instant(
            `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.ACCEPTANCE_NEEDED]}.lock.type.${
              CubiqTS.LockType[CubiqTS.LockType.MODIFY_LOCK]
            }`,
          );
        } else {
          return this.translateService.instant(
            `order.state.${
              CubiqTS.OrderState[CubiqTS.OrderState.ACCEPTANCE_NEEDED]
            }.lock.type.none`,
          );
        }
      case CubiqTS.OrderState.REJECTED:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.REJECTED]}`,
        );
      case CubiqTS.OrderState.PRICING:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.PRICING]}`,
        );
      case CubiqTS.OrderState.FILL_ERROR:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.FILL_ERROR]}`,
        );
      case CubiqTS.OrderState.SAVED:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.SAVED]}`,
        );
      case CubiqTS.OrderState.ACTIVE:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.ACTIVE]}`,
        );
      case CubiqTS.OrderState.FILLED:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.FILLED]}`,
        );
      case CubiqTS.OrderState.CANCELLED:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.CANCELLED]}`,
        );
      case CubiqTS.OrderState.EXPIRED:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.EXPIRED]}`,
        );
      case CubiqTS.OrderState.FILL_EXPIRED:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.FILL_EXPIRED]}`,
        );
      case CubiqTS.OrderState.TRIGGERED:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.TRIGGERED]}`,
        ); //this was a transitin state in oms but cubiq is returning it the same as manual pricing
      case CubiqTS.OrderState.DELETED:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.DELETED]}`,
        );
      case CubiqTS.OrderState.PENDING:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.PENDING]}`,
        );
      case CubiqTS.OrderState.MANUAL_PRICING:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.MANUAL_PRICING]}`,
        );
      case CubiqTS.OrderState.PENDING_CANCELLATION:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.PENDING_CANCELLATION]}`,
        );
      case CubiqTS.OrderState.IN_MODIFICATION:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.IN_MODIFICATION]}`,
        );
      case CubiqTS.OrderState.MODIFY_ACCEPTANCE_NEEDED:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.MODIFY_ACCEPTANCE_NEEDED]}`,
        );
      case CubiqTS.OrderState.CANCEL_ACCEPTANCE_NEEDED:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.CANCEL_ACCEPTANCE_NEEDED]}`,
        );
      case CubiqTS.OrderState.GAMMA_MID_PENDING:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.GAMMA_MID_PENDING]}`,
        );
      case CubiqTS.OrderState.MIGRATION_ACCEPTANCE_NEEDED:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.MIGRATION_ACCEPTANCE_NEEDED]}`,
        );
      case CubiqTS.OrderState.SUSPENDED:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.SUSPENDED]}`,
        );
      case CubiqTS.OrderState.ENTRYPRICING:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.ENTRYPRICING]}`,
        );
      case CubiqTS.OrderState.EXPIRY_ACCEPTANCE_NEEDED:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.EXPIRY_ACCEPTANCE_NEEDED]}`,
        );
      case CubiqTS.OrderState.TRIGGERED_EXPIRY_ACCEPTANCE_NEEDED:
        return this.translateService.instant(
          `order.state.${
            CubiqTS.OrderState[CubiqTS.OrderState.TRIGGERED_EXPIRY_ACCEPTANCE_NEEDED]
          }`,
        );
      case CubiqTS.OrderState.FILLING:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.FILLING]}`,
        );
      case CubiqTS.OrderState.EXT_ACCEPTANCE_NEEDED:
        switch (lockType) {
          case CubiqTS.LockType.MODIFY_LOCK:
            return this.translateService.instant(
              "order.state.EXT_ACCEPTANCE_NEEDED.lock.type.MODIFY_LOCK",
            );
          case CubiqTS.LockType.FILL_NOW_LOCK:
            return this.translateService.instant(
              "order.state.EXT_ACCEPTANCE_NEEDED.lock.type.FILL_NOW_LOCK",
            );
          default:
            return this.translateService.instant(
              `order.state.${
                CubiqTS.OrderState[CubiqTS.OrderState.EXT_ACCEPTANCE_NEEDED]
              }.lock.type.none`,
            );
        }
        break;
      case CubiqTS.OrderState.EXT_MODIFY_ACCEPTANCE_NEEDED:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.EXT_MODIFY_ACCEPTANCE_NEEDED]}`,
        );
      case CubiqTS.OrderState.EXT_CANCEL_ACCEPTANCE_NEEDED:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.EXT_CANCEL_ACCEPTANCE_NEEDED]}`,
        );
      case CubiqTS.OrderState.MATCHED:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.MATCHED]}`,
        );
      case CubiqTS.OrderState.FILL_PENDING:
        return this.translateService.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.FILL_PENDING]}`,
        );

      case CubiqTS.OrderState.PENDING_FWDS:
      case CubiqTS.OrderState.CANCEL_PENDING_FWDS:
      case CubiqTS.OrderState.EXPIRY_PENDING_FWDS: {
        return this.translateService.instant(`order.state.${CubiqTS.OrderState[state]}`);
      }
    }

    return "";
  }
}
